import { atom } from 'jotai'

/**
 * 配車板上で「この依頼が載っている矢羽根」を探して見せるための依頼ID。
 *
 * ドロワーの配車済みカードをクリックすると set され、配車板側がその依頼を含む
 * 車両行までスクロールして矢羽根を一定時間強調する（#4488 VOC_PJ-948）。
 * カード側は矢羽根 ID を持たない（API が返す配車先は車両コード等の表示値のみ）ため、
 * 板が持つ行データを依頼IDで逆引きする。該当矢羽根が板の表示範囲に無い場合は何もしない
 * （ドロワーは発送日で絞られており、板の日付範囲外の依頼は原則ここに来ない）。
 * 強調が終わったら配車板側が null に戻す。
 */
export const focusedDispatchedShipmentOrderIdAtom = atom<number | null>(null)

focusedDispatchedShipmentOrderIdAtom.debugLabel =
  'focusedDispatchedShipmentOrderIdAtom'
